import { Outlet } from 'react-router'
import React from 'react'

const WorkMergeLayout = () => (
    <>
        <title>Work Merge Tool</title>
        <Outlet />
    </>
)

export default WorkMergeLayout
